export default "__VITE_ASSET__BEP52EDu__"